<div class="s1 _price"
     scrollTo="#product-details">
    @if (productConfiguration().orgPrice()) {
    <price class="m-r-1 col-13 line-through"
           [value]="productConfiguration().orgPrice()" />
    }
    <price [value]="productConfiguration().price()" />
</div>
<product-layout-add-to-basket [panel]="true"
                              [productViewLayout]="productViewLayout()" />
@if (hasColorOption) {
<button class="_palette"
        uiButton
        (click)="handlePaletteClick()">
    <i></i>
</button>
}